var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowEscalator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 28,
    viewBox: "0 0 37 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1172_805)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8842 12.2192C14.5795 12.2192 13.5016 13.2975 13.5016 14.6027V17.9513L17.9264 13.4111C17.5291 12.7299 16.7919 12.2192 15.8842 12.2192Z",
    fill: "#353E5A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8274 8.7573C18.0398 8.7573 19.7983 6.9982 19.7983 4.7849C19.7983 2.5717 18.0398 0.8125 15.8274 0.8125C13.6151 0.8125 11.8566 2.5717 11.8566 4.7849C11.8562 6.9982 13.6717 8.7573 15.8274 8.7573ZM17.5294 4.8416C17.5294 3.8768 16.7352 3.139 15.8274 3.139C14.9197 3.139 14.1255 3.8769 14.1255 4.8416C14.1255 5.8063 14.8631 6.5442 15.8274 6.5442C16.7918 6.5442 17.5294 5.8063 17.5294 4.8416Z",
    fill: "#353E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5148 11.7083C18.664 10.6299 17.359 9.89209 15.8277 9.89209C13.275 9.89209 11.1758 11.9917 11.1758 14.5458V20.2775L13.5016 17.9514V14.6028C13.5016 13.2976 14.5795 12.2193 15.8842 12.2193C16.7919 12.2193 17.5291 12.73 17.9264 13.4112L19.5148 11.7083Z",
    fill: "#353E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8274 3.13916C16.7352 3.13916 17.5294 3.87696 17.5294 4.84176C17.5294 5.80646 16.7918 6.54436 15.8274 6.54436C14.8631 6.54436 14.1255 5.80646 14.1255 4.84176C14.1255 3.87706 14.9197 3.13916 15.8274 3.13916Z",
    fill: "#353E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5864 12.0599H27.4232C27.0963 12.0599 26.7042 12.1846 26.5082 12.4334L12.456 26.1917H4.35136C2.78256 26.1917 1.47546 24.9467 1.47546 23.4524C1.47546 21.958 2.78246 20.7131 4.35136 20.7131H9.44936C9.77626 20.7131 10.1684 20.5884 10.3644 20.3396L24.4166 6.51904H32.5865C34.1552 6.51904 35.4624 7.76404 35.4624 9.25844C35.4628 10.7523 34.1547 12.0599 32.5864 12.0599Z",
    fill: "#353E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5864 12.0599H27.4232C27.0963 12.0599 26.7042 12.1846 26.5082 12.4334L12.456 26.1917H4.35136C2.78256 26.1917 1.47546 24.9467 1.47546 23.4524C1.47546 21.958 2.78246 20.7131 4.35136 20.7131H9.44936C9.77626 20.7131 10.1684 20.5884 10.3644 20.3396L24.4166 6.51904H32.5865C34.1552 6.51904 35.4624 7.76404 35.4624 9.25844C35.4628 10.7523 34.1547 12.0599 32.5864 12.0599Z",
    fill: "#353E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5864 12.0599H27.4232C27.0963 12.0599 26.7042 12.1846 26.5082 12.4334L12.456 26.1917H4.35136C2.78256 26.1917 1.47546 24.9467 1.47546 23.4524C1.47546 21.958 2.78246 20.7131 4.35136 20.7131H9.44936C9.77626 20.7131 10.1684 20.5884 10.3644 20.3396L24.4166 6.51904H32.5865C34.1552 6.51904 35.4624 7.76404 35.4624 9.25844C35.4628 10.7523 34.1547 12.0599 32.5864 12.0599Z",
    stroke: "#353E5A",
    strokeWidth: 2.0362,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1172_805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowEscalator);
export default __webpack_public_path__ + "static/media/arrow_escalator.4bea48344ca9d328b294f7b6720e0d33.svg";
export { ForwardRef as ReactComponent };